import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axiosInstance from '../../Services/AxiosAPICaller';
import { IContactGroups } from '../../Interfaces/IContactsGroups';
import './ContactGroupGetter.css';

interface ContactGroupProps {
  BulleId?:  number | null;
}

const ContactGroupGetter: React.FC<ContactGroupProps> = ({ BulleId }) => {

  const [ContactGroups, setContactGroup] = useState<IContactGroups[]>([]);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => 
    {
      // Remplacez l'URL par l'endpoint réel de votre API
      axiosInstance.get< { data: { id: number, attributes: any }[]}>(`/groupes-de-contacts?populate[bulle][fields][0]=Id&filters[bulle][id]=${BulleId}`)
      .then(response => 
        {
          // check if returned data is an array
          if (Array.isArray(response.data.data))
          {
          
            // Create ContactGroup Object From API returned Datas
            const ContactGroup = response.data.data.map(item => (
              {
                Id: item.id,
                Name:item.attributes.Nom,
                Description: item.attributes.Description,
                Image: item.attributes.Image,
                Bubble: item.attributes.bulle, 
                Contacts: item.attributes.contacts ?? null 
              }));

              setContactGroup(ContactGroup);
          } 
          else 
          {
            setError('La réponse de l\'API n\'est pas un tableau.');
            console.error('La réponse de l\'API n\'est pas un tableau.');
          }
      })
      .catch(error => {
        console.error('Erreur lors de la récupération des objets :', error);
      });
    }, [BulleId]);
    return (
      <div className="ContactGroupContainer">
        {
          error && <p>{error}</p>
        }
        
        {
          ContactGroups.length > 0 ? (
            ContactGroups.map(Cg => (
            <Link to={`/ContactGroup/${Cg.Id}`} key={Cg.Id} className={`ContactGroupBtn`}>{Cg.Name}
            </Link>
          ))
          ) : (
          <p>Aucuns groupes de contacts à afficher.</p>
        )
        }
      </div>
    );
}

export default ContactGroupGetter;